/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Image, ImageFit, Icon } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { Goals, getStepGoalOptionsImages } from './consts';

import { getStyles } from './styles';

export function GoalItem(props) {
  const {
    i18n,
    id,
    itemIndex,
    selectedCampaignGoals,
    isShowIcon,
  } = props;

  const classes = useDefaultStyles(getStyles);
  const campaignGoal = useMemo(() => Goals[id], [id]);
  const isSelected = useMemo(() => _.contains(selectedCampaignGoals, id), [id, selectedCampaignGoals]);
  const stepGoalOptionsImages = useMemo(() => getStepGoalOptionsImages(isShowIcon), [isShowIcon]);
  const goalImage = useMemo(() => (
    isSelected && isShowIcon ? stepGoalOptionsImages.GoalSelected : stepGoalOptionsImages[id]
  ), [id, isSelected, isShowIcon, stepGoalOptionsImages]);

  return (
    <div
      data-is-focusable
      data-selection-invoke
      data-selection-index={itemIndex}
      className={classNames(
          'campaign-goal-item',
          classes.campaignGoalItemContainer,
          { 'is-selected': isSelected },
          isShowIcon ? classes.campaignGoalItemContainerWithIcon : classes.campaignGoalItemContainerWithoutIcon
        )}
      tabIndex={0}
      role="checkbox"
      aria-checked={isSelected}
    >
      <Image
        src={goalImage.imageSrc}
        alt={i18n.getString(goalImage.alt)}
        className={classNames(classes.image, isShowIcon ? classes.iconImage : classes.nonIconImage)}
        imageFit={ImageFit.contain}
        aria-hidden="true"
      />
      {
        !isShowIcon &&
        <Icon
          className={classNames(
            'campaign-goal-item-checkbox',
            !isSelected && 'non-hover-check-icon',
            classes.checkIcon,
            isSelected ? classes.checkIconHightLight : classes.checkIconNonHightLight
          )}
          iconName={isSelected ? 'CheckboxCompositeReversed' : 'Checkbox'}
          aria-hidden="true"
        />
      }

      {
        !isShowIcon && !isSelected &&
        <Icon
          className={classNames(
            classes.checkIcon,
            classes.checkIconUncheckHover,
            'hovered-check-icon'
          )}
          iconName="CheckboxComposite"
          aria-hidden="true"
          title={i18n.getString(_TL_('checkbox'))}
        />
      }

      <div className={classes.goalTitle} >
        {i18n.getString(campaignGoal.title)}
      </div>
      {
        campaignGoal.isRecommended &&
        <div className={classes.goalDescription}>
          {i18n.getString(_TL_('(recommended)'))}
        </div>
      }
    </div>
  );
}

GoalItem.propTypes = {
  i18n: PropTypes.shape({ getString: PropTypes.func.isRequired }).isRequired,
  id: PropTypes.string.isRequired,
  itemIndex: PropTypes.number.isRequired,
  selectedCampaignGoals: PropTypes.arrayOf(PropTypes.string).isRequired,
  isShowIcon: PropTypes.bool.isRequired,
};
